export const COLUMNS = [
  { label: 'Adviser name', key: 'adviserName', type: 'string' },
  { label: 'Adviser code', key: 'adviserCode', type: 'string' },
  { label: 'Policy', key: 'number', type: 'number' },
  { label: 'Product', key: 'productName', type: 'string' },
  { label: 'Status', key: 'statusCode', type: 'string' },
  { label: 'Life assured', key: 'lifeAssuredFullName', type: 'string' },
  { label: 'API', key: 'pendingApiInclGst', type: 'number' },
  { label: 'Anniversary', key: 'anniversary', type: 'string' },
  { label: 'Arrears', key: 'arrears', type: 'string' }
];

export const NO_RESULTS_FOUND_TEXT = 'No results found';
export const NO_REQUIREMENTS_TEXT = 'Currently there are no requirements';
